import { ValidationError } from '@zimpel/common/newApi';
import type { ValidationErrors } from '@zimpel/common/newApi';
import useHandleErrors from '@zimpel/common/hooks/useHandleErrors';

type FormikOptions = {
  setErrors?: (validationErrors: ValidationErrors) => void;
};

type EitherOr<T, U> = [T, undefined] | [undefined, U];

export type HandleValidationErrorsResult<T> = Promise<EitherOr<T, ValidationErrors>>

type HandleValidationErrors = <T, >(options: FormikOptions, cb: () => Promise<T>) => HandleValidationErrorsResult<T>;

const useHandleValidationErrors: () => HandleValidationErrors = () => {
  const handleErrors = useHandleErrors();

  return async ({ setErrors }, cb) => (
    handleErrors(async () => {
      try {
        return [await cb(), undefined];
      } catch (error) {
        if (error instanceof ValidationError) {
          if (setErrors) {
            setErrors(error.validationErrors);
          }
          return [undefined, error.validationErrors];
        }
        throw error;
      }
    })
  );
};

export default useHandleValidationErrors;
